<template>
  <div class="user-list-container">
    <el-card class="page-header-card" shadow="hover">
      <div class="page-header">
        <div class="page-title-section">
          <h2 class="page-title">
            <font-awesome-icon icon="users" class="page-title-icon" />
            Хэрэглэгч удирдах хэсэг
          </h2>
          <p class="page-subtitle">Хэрэглэгчдийг үүсгэх, засах, устгах</p>
        </div>
        <el-button
          v-if="checkPermissionsPage('admin')"
          @click="createUserDialogOpen()"
          type="primary"
          size="large"
          class="create-button"
        >
          <font-awesome-icon icon="plus" class="button-icon" />
          Шинэ хэрэглэгч үүсгэх
        </el-button>
      </div>
    </el-card>

    <el-card class="content-card mt-10" shadow="hover">
      <template #header>
        <div class="search-header">
          <font-awesome-icon icon="magnifying-glass" class="search-icon" />
          <span class="search-title">Хайлт</span>
        </div>
      </template>
      <div class="search-section">
        <el-input
          placeholder="Утасны дугаар шүүх"
          v-model="searchItems.searchPhone"
          class="search-input"
          clearable
        >
          <template #prefix>
            <font-awesome-icon icon="phone" />
          </template>
        </el-input>
        <el-input
          placeholder="Нэрээр шүүх"
          v-model="searchItems.searchName"
          class="search-input"
          clearable
        >
          <template #prefix>
            <font-awesome-icon icon="user" />
          </template>
        </el-input>
        <el-button
          @click="searchUsers()"
          type="primary"
          size="large"
          class="search-button"
        >
          <font-awesome-icon icon="magnifying-glass" class="button-icon" />
          Хайх
        </el-button>
      </div>
    </el-card>

    <el-card class="table-card mt-10" shadow="hover">
      <template #header>
        <div class="table-header">
          <font-awesome-icon icon="table" class="table-header-icon" />
          <span class="table-header-title">Хэрэглэгчдийн жагсаалт</span>
          <el-tag type="info" class="table-count-tag">{{ data.length }} хэрэглэгч</el-tag>
        </div>
      </template>
      <el-table
        style="width: 100%"
        border
        class="modern-user-table"
        :data="data"
        stripe
      >
          <!-- Checkbox Column -->
          <!-- Static Columns -->
          <el-table-column label="№" type="index"></el-table-column>
          <el-table-column label="Утасны дугаар" prop="phone1"></el-table-column>
          <el-table-column label="Нэр" prop="firstName"></el-table-column>
          <el-table-column label="Овог" prop="lastName"></el-table-column>
          <el-table-column label="Мэйл" prop="email"></el-table-column>

          <!-- Actions Column -->
          <el-table-column label="Үйлдэл" width="450" v-if="checkPermissionsPage('admin')" align="center">
            <template v-slot="scope">
              <el-button-group>
                <el-button
                  v-if="checkPermissionsPage('admin')"
                  @click="createAddressDialogOpen(scope.row)"
                  type="warning"
                  size="small"
                  class="action-button"
                >
                  <font-awesome-icon icon="map-marker-alt" class="button-icon-small" />
                  Хаяг
                </el-button>
                <el-button
                  v-if="checkPermissionsPage('admin')"
                  @click="createUserDialogOpen(scope.row)"
                  size="small"
                  class="action-button"
                >
                  <font-awesome-icon icon="edit" class="button-icon-small" />
                  Засварлах
                </el-button>
                <el-button
                  v-if="checkPermissionsPage('admin')"
                  @click="openResetPasswordDialog(scope.row)"
                  type="success"
                  size="small"
                  class="action-button"
                >
                  <font-awesome-icon icon="key" class="button-icon-small" />
                  Нууц үг
                </el-button>
                <el-button
                  v-if="checkPermissionsPage('admin')"
                  @click="deleteRow(scope.row)"
                  type="danger"
                  size="small"
                  class="action-button"
                >
                  <font-awesome-icon icon="trash" class="button-icon-small" />
                  Устгах
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- Pagination -->
        <el-pagination
          @current-change="handlePageChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="totalRecords"
          layout="total, prev, pager, next, jumper"
          class="modern-pagination" />
    </el-card>
    <CreateUserDialog :selectedUser="this.targetUser"/>
    <CreateAddressDialog :selectedUser="this.targetUser"/>

    <el-dialog
      v-model="resetPasswordDialog"
      title="Нууц үг солих"
      width="420px"
      :close-on-click-modal="false"
      @closed="resetPasswordForm"
    >
      <div v-if="passwordTargetUser" class="password-user-info">
        {{ passwordTargetUser.firstName || '' }} {{ passwordTargetUser.lastName || '' }}
        <span v-if="passwordTargetUser.phone1">({{ passwordTargetUser.phone1 }})</span>
      </div>
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordFormRef" label-position="top">
        <el-form-item label="Шинэ нууц үг" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            show-password
            placeholder="Шинэ нууц үг оруулна уу"
          />
        </el-form-item>
        <el-form-item label="Нууц үг давтах" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            show-password
            placeholder="Нууц үгээ дахин оруулна уу"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="resetPasswordDialog = false">Болих</el-button>
        <el-button type="primary" :loading="passwordSaving" @click="submitResetPassword">
          Хадгалах
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import services from '@/services'
import { checkPermissions } from '@/helpers/custom'
import { ElMessage, ElMessageBox } from 'element-plus'
import CreateUserDialog from './createUserDialog.vue'
import CreateAddressDialog from './createAddressDialog.vue'
import { mapActions } from 'vuex'

export default {
  name: 'UserListPage',
  components: {
    CreateUserDialog,
    CreateAddressDialog
  },
  created () {
    this.loadData()
  },
  data () {
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Нууц үгээ давтан оруулна уу'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('Нууц үг таарахгүй байна'))
      } else {
        callback()
      }
    }

    return {
      createAddressDialog: false,
      currentPage: 1,
      pageSize: 10,
      data: [],
      // Example dynamic columns
      columns: [],
      targetUser: {},
      searchItems: {
        searchPhone: null,
        searchName: null
      },
      totalRecords: null,
      resetPasswordDialog: false,
      passwordSaving: false,
      passwordTargetUser: null,
      passwordForm: {
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        newPassword: [
          { required: true, message: 'Шинэ нууц үг оруулна уу', trigger: 'blur' },
          { min: 3, message: 'Нууц үг хамгийн багадаа 3 тэмдэгт байх ёстой', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['setCreateUserDialog', 'setCreateAddressDialog']),
    loadColumns () {
      const columns = [{
        label: 'Нэр',
        prop: 'firstName',
        type: 'text',
        required: true
      },
      {
        label: 'Овог',
        prop: 'lastName',
        type: 'text',
        required: true
      },
      {
        label: 'Утасны дугаар',
        prop: 'phone1',
        type: 'text',
        required: true
      },
      {
        label: 'Мэйл',
        prop: 'email',
        type: 'text',
        required: false
      }
      ]
      this.columns = columns // Багануудыг хадгалах
    },
    async loadData () {
      try {
        const response = await services.get('users', {
          params: {
            page: this.currentPage, // Одоогийн хуудас
            limit: this.pageSize // Хуудасны хэмжээ
          }
        })
        if (response) {
          this.data = response.data
          this.totalRecords = response.total// Pagination тоо
          this.totalPages = response.totalPages
        } else {
          // Хариулт дотор data байхгүй бол алдаа харуулна
          ElMessage.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        console.error('Error fetching data: ', error)
        // Алдааг консолоор илүү дэлгэрэнгүй харуулах
        ElMessage.error(`Өгөгдөл ачаалахад алдаа гарлаа: ${error.message}`)
      }
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    },
    handlePageChange (page) {
      this.currentPage = page
      if (this.searchItems.searchPhone || this.searchItems.searchName) {
        this.searchUsers(false)
      } else {
        this.loadData()
      }
    },
    editRow (row) {
      // Edit functionality here
      console.log('Edit Row: ', row)
      // Open dialog for editing...
    },
    createUserDialogOpen (data) {
      this.targetUser = data
      this.setCreateUserDialog(true)
    },
    createAddressDialogOpen (data) {
      this.targetUser = data
      this.setCreateAddressDialog(true)
    },
    openResetPasswordDialog (row) {
      this.passwordTargetUser = row
      this.passwordForm = {
        newPassword: '',
        confirmPassword: ''
      }
      this.resetPasswordDialog = true
      this.$nextTick(() => {
        this.$refs.passwordFormRef?.clearValidate()
      })
    },
    resetPasswordForm () {
      this.passwordTargetUser = null
      this.passwordForm = {
        newPassword: '',
        confirmPassword: ''
      }
      this.passwordSaving = false
    },
    submitResetPassword () {
      this.$refs.passwordFormRef.validate(async (valid) => {
        if (!valid) return

        try {
          this.passwordSaving = true
          const response = await services.post('adminResetPassword', {
            user_id: this.passwordTargetUser.id,
            new_password: this.passwordForm.newPassword,
            re_new_password: this.passwordForm.confirmPassword
          })

          if (response.type === 'success') {
            ElMessage.success(response.message || 'Нууц үг амжилттай солигдлоо.')
            this.resetPasswordDialog = false
          } else {
            ElMessage.error(response.message || 'Нууц үг солиход алдаа гарлаа.')
          }
        } catch (error) {
          ElMessage.error(error.message || 'Нууц үг солиход алдаа гарлаа.')
        } finally {
          this.passwordSaving = false
        }
      })
    },
    async deleteRow (row) {
      try {
        await ElMessageBox.confirm('Та энэ бичлэгийг устгахдаа итгэлтэй байна уу?', 'Баталгаажуулалт', {
          confirmButtonText: 'Тийм',
          cancelButtonText: 'Үгүй',
          type: 'warning'
        })

        // API устгах хүсэлт явуулах
        await services.delete('users', row.id)

        // Success message
        ElMessage.success('Амжилттай устгагдлаа!')
        this.loadData()
        // Remove row from data after deletion
        const index = this.data.indexOf(row)
        if (index > -1) {
          this.data.splice(index, 1)
        }
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('Устгахад алдаа гарлаа!')
        }
      }
    },
    async searchUsers (resetPage = true) {
      try {
        const phone1 = (this.searchItems.searchPhone || '').toString().trim()
        const firstName = (this.searchItems.searchName || '').toString().trim()

        if (resetPage) {
          this.currentPage = 1
        }

        if (!phone1 && !firstName) {
          await this.loadData()
          return
        }

        const response = await services.post(
          'searchUser',
          {
            phone1: phone1 || undefined,
            first_name: firstName || undefined,
            last_name: firstName || undefined
          },
          {
            params: {
              page: this.currentPage,
              limit: this.pageSize
            }
          }
        )

        if (response) {
          this.data = response.data || []
          this.totalRecords = response.total
          this.totalPages = response.totalPages
          if (!this.data.length) {
            ElMessage.info('Хайлтын үр дүн олдсонгүй.')
          }
        } else {
          ElMessage.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        console.error('Error fetching data: ', error)
        ElMessage.error(`Өгөгдөл ачаалахад алдаа гарлаа: ${error.message}`)
      }
    }
  }
}

</script>
<style lang="scss" scoped>
/* User List Container */
.user-list-container {
  padding: 0;
}

/* Page Header Card */
.page-header-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
  margin-bottom: 24px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.page-title-section {
  flex: 1;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title-icon {
  color: #667eea;
  font-size: 32px;
}

.page-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.create-button {
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.create-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.button-icon {
  margin-right: 8px;
}

/* Content Card */
.content-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
}

.search-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.search-icon {
  color: #667eea;
}

.search-title {
  color: #1f2937;
}

.search-section {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.search-input {
  flex: 1;
  min-width: 200px;
}

.search-input :deep(.el-input__inner) {
  border-radius: 8px;
  padding-left: 36px;
}

.search-button {
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 600;
}

/* Table Card */
.table-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
}

.table-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-header-icon {
  color: #667eea;
  font-size: 20px;
}

.table-header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  flex: 1;
}

.table-count-tag {
  border-radius: 20px;
  padding: 4px 12px;
}

/* Modern User Table */
.modern-user-table {
  border-radius: 8px;
  overflow: hidden;
}

.modern-user-table :deep(.el-table__header) {
  background: #f9fafb;
}

.modern-user-table :deep(.el-table__header th) {
  background: #f9fafb;
  color: #374151;
  font-weight: 600;
  border-bottom: 2px solid #e5e7eb;
  padding: 16px 0;
}

.modern-user-table :deep(.el-table__body tr:hover) {
  background: #f3f4f6;
}

.modern-user-table :deep(.el-table__body td) {
  padding: 16px 0;
}

/* Action Buttons */
.action-button {
  border-radius: 6px;
  transition: all 0.2s ease;
}

.action-button:hover {
  transform: translateY(-1px);
}

.button-icon-small {
  margin-right: 4px;
  font-size: 12px;
}

/* Pagination */
.modern-pagination {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

.password-user-info {
  margin-bottom: 16px;
  font-weight: 600;
  color: #374151;
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .page-title {
    font-size: 24px;
  }

  .search-section {
    flex-direction: column;
  }

  .search-input {
    width: 100%;
  }

  .action-button {
    margin-bottom: 4px;
  }

  /* Mobile Table Scroll */
  .table-card {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .modern-user-table {
    min-width: 600px;
  }

  .action-button {
    font-size: 11px;
    padding: 6px 8px;
  }

  .button-icon-small {
    display: none;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .page-subtitle {
    font-size: 12px;
  }

  .create-button {
    width: 100%;
    margin-top: 8px;
  }
}
</style>
